import Link from 'next/link'
import { ReactNode } from 'react'

interface SliderImageWrapperProps {
  link?: string
  children?: ReactNode
}

export const SliderImageWrapper = ({
  link,
  children,
}: SliderImageWrapperProps) => {
  if (link) {
    return <Link href={link}>{children}</Link>
  }

  return <>{children}</>
}
